/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import AbsoluteDropdownContainer from 'ui-library/AbsoluteDropdownContainer';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import ColorPicker, {ColorPickerProps} from 'ui-library/ColorPicker';
import {ColorValueLink} from 'ui-library/ColorPickerConstants';
import ColorPickerIcon, {ColorPickerIconProps} from 'ui-library/icons/ColorPickerIcon';

export interface ColorPickerDropdownProps extends Pick<
  ColorPickerProps,
  'foregroundName' | 'backgroundName'
> {
  foregroundColorLink: ColorValueLink;
  backgroundColorLink: ColorValueLink;
  className?: string;
  disabled?: boolean;
  buttonStyle?: ButtonStyle;
  /**
   * Icon to display in the button.
   *
   * @default 'font'
   */
  icon?: ColorPickerIconProps['icon'];
  iconAltText?: string;
}

type State = any;

class ColorPickerDropdown extends React.Component<ColorPickerDropdownProps, State> {
  override state: State = {open: false};

  _handleButtonClick = (): void => {
    this.setState({open: true});
  };

  _handleDropdownClose = (): void => {
    this.setState({open: false});
  };

  override render(): JSX.Element {
    return (
      <div className="colorPickerDropdown dropdown">
        <AbsoluteDropdownContainer
          open={this.state.open}
          onRequestClose={this._handleDropdownClose}
          menu={
            <div className="colorPickerDropdown-menu dropdown-menu">
              <ColorPicker
                foregroundColorLink={this.props.foregroundColorLink}
                backgroundColorLink={this.props.backgroundColorLink}
                foregroundName={this.props.foregroundName}
                backgroundName={this.props.backgroundName}
                onRequestClose={this._handleDropdownClose}
              />
            </div>
          }
        >
          <Button
            buttonStyle={this.props.buttonStyle ?? ButtonStyle.TERTIARY_GRAY}
            icon={
              <ColorPickerIcon
                icon={this.props.icon}
                iconAltText={this.props.iconAltText}
                foregroundColor={this.props.foregroundColorLink.value as string}
                backgroundColor={this.props.backgroundColorLink.value as string}
              />
            }
            isDropdown={true}
            disabled={this.props.disabled}
            onClick={this._handleButtonClick}
            size={ButtonSize.MINI}
            className={this.props.className}
          />
        </AbsoluteDropdownContainer>
      </div>
    );
  }
}

export default ColorPickerDropdown;
